import { dynamicWrapper, createRoute } from '@/utils/core';

const routesConfig = (app) => ({
  path: '/sign/retrieve',
  title: window.language['retrieve'],
  component: dynamicWrapper(app, [import('./model')], () => import('./components')),
});

export default (app) => createRoute(app, routesConfig);



// WEBPACK FOOTER //
// ./src/routes/Retrieve/index.js